import { isModuleResponseDTO, ModuleResponseApi } from "../Module/Module";

export interface LearningPathModuleResponseApi {
  learningPathModuleId: string;
  module: ModuleResponseApi;
  learningPathModuleOrder: number;
}

export class LearningPathModuleResponseImpl {
  learningPathModuleId: string;
  module: ModuleResponseApi;
  learningPathModuleOrder: number;

  constructor(learningPathModule: LearningPathModuleResponseApi) {
    this.learningPathModuleId = learningPathModule.learningPathModuleId;
    this.module = learningPathModule.module;
    this.learningPathModuleOrder = learningPathModule.learningPathModuleOrder;
  }
}

export let isLearningPathModuleResponseDTO = (
  variable: unknown
): variable is LearningPathModuleResponseApi => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "object" &&
    "learningPathModuleId" in variable &&
    typeof variable.learningPathModuleId === "string" &&
    "learningPathModuleOrder" in variable &&
    typeof variable.learningPathModuleOrder === "number" &&
    "module" in variable &&
    isModuleResponseDTO(variable.module)
  );
};
